import React from 'react';
import FileUtils from 'application/utils/FileUtils';

import VideoMediafilesPreviewItemSkeleton from 'application/components/VideoMediafilePreviewItemSkeleton';
import VideoMediafilePreviewItemContent from 'application/components/VideoMediafilePreviewItem/VideoMediafileItemContent';
import { DEFAULT_PREVIEW_DURATION } from 'application/components/VideoMediafileItemPoster/consts';
import styles from './content.module.scss';

import { SelectVideoMediafilePreviewItemProps } from './types';

const VideoStreamPreviewItem: React.FC<SelectVideoMediafilePreviewItemProps> = ({
  file,
  className,
  actionText,
  actionHandler,
}) => (
  <div className={className}>
    {file ? (
      <VideoMediafilePreviewItemContent
        contentClassName={styles.content}
        detailsClassName={styles.details}
        titleClassName={styles.title}
        descriptionClassName={styles.description}
        popperClassName={styles.popper}
        imgLink={file.previewUrl}
        title={file.title}
        uploading={file.uploading}
        duration={file.duration || DEFAULT_PREVIEW_DURATION}
        actionHandler={actionHandler}
        actionText={actionText}
        extension={FileUtils.getOriginalMediafileSource(file.sourcefiles)?.extension}
      />
    ) : (
      <VideoMediafilesPreviewItemSkeleton />
    )}
  </div>
);

export default VideoStreamPreviewItem;
